import { render, staticRenderFns } from "./showFile.vue?vue&type=template&id=350c38b7&scoped=true"
import script from "./showFile.vue?vue&type=script&lang=js"
export * from "./showFile.vue?vue&type=script&lang=js"
import style0 from "./showFile.vue?vue&type=style&index=0&id=350c38b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350c38b7",
  null
  
)

export default component.exports